
import.meta.glob([
    '../images/**',
    '../fonts/**',
]);

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-carousel]').forEach((section) => {
        const viewport = section.querySelector('[data-carousel-viewport]');
        const previousButton = section.querySelector('[data-carousel-previous]');
        const nextButton = section.querySelector('[data-carousel-next]');

        if (!viewport || !previousButton || !nextButton) {
            return;
        }

        section.querySelectorAll('[data-carousel-product-image]').forEach((image) => {
            const useFallbackImage = () => {
                const fallbackSrc = image.dataset.fallbackSrc;

                if (!fallbackSrc || image.src === fallbackSrc) {
                    return;
                }

                image.src = fallbackSrc;

                const buyButton = image.closest('.recently-viewed-card')?.querySelector('[data-product-buy]');
                if (buyButton) {
                    buyButton.dataset.image = fallbackSrc;
                }
            };

            image.addEventListener('error', useFallbackImage, { once: true });

            if (image.complete && image.naturalWidth === 0) {
                useFallbackImage();
            }
        });

        const getScrollStep = () => {
            const card = viewport.querySelector('.recently-viewed-card');
            const track = viewport.querySelector('.recently-viewed__track');
            const gap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;

            return card ? card.getBoundingClientRect().width + gap : viewport.clientWidth;
        };

        let animationFrame = null;
        let targetScrollLeft = viewport.scrollLeft;

        const scrollToCard = (direction) => {
            const step = getScrollStep();
            const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
            const baseScrollLeft = animationFrame === null ? viewport.scrollLeft : targetScrollLeft;
            const nextTarget = Math.min(maxScrollLeft, Math.max(0, baseScrollLeft + direction * step));

            if (animationFrame !== null) {
                cancelAnimationFrame(animationFrame);
            }

            targetScrollLeft = nextTarget;

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                viewport.classList.remove('is-animating');
                viewport.scrollLeft = targetScrollLeft;
                animationFrame = null;
                return;
            }

            viewport.classList.add('is-animating');

            const startScrollLeft = viewport.scrollLeft;
            const distance = targetScrollLeft - startScrollLeft;
            const startTime = performance.now();
            const duration = 720;

            const animate = (currentTime) => {
                const progress = Math.min((currentTime - startTime) / duration, 1);
                const easedProgress = progress < 0.5
                    ? 4 * Math.pow(progress, 3)
                    : 1 - Math.pow(-2 * progress + 2, 3) / 2;

                viewport.scrollLeft = startScrollLeft + distance * easedProgress;

                if (progress < 1) {
                    animationFrame = requestAnimationFrame(animate);
                    return;
                }

                viewport.scrollLeft = targetScrollLeft;
                viewport.classList.remove('is-animating');
                animationFrame = null;
                updateButtons();
            };

            animationFrame = requestAnimationFrame(animate);
        };

        const updateButtons = () => {
            const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
            previousButton.disabled = viewport.scrollLeft <= 2;
            nextButton.disabled = viewport.scrollLeft >= maxScrollLeft - 2;
            section.classList.toggle('product-carousel--static', maxScrollLeft <= 2);
        };

        previousButton.addEventListener('click', () => {
            scrollToCard(-1);
        });

        nextButton.addEventListener('click', () => {
            scrollToCard(1);
        });

        viewport.addEventListener('scroll', () => {
            if (animationFrame === null) {
                targetScrollLeft = viewport.scrollLeft;
            }

            updateButtons();
        }, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
    });
});
